<style lang="less">
@import "../../styles/public/public.less";
.theme {
  width: 100%;
  height: 100%;
  .theme_1 {
    padding: 25px 0px 0px 0px;
    width: 100%;
    height: 100%;
    .display_row;
    .theme_left {
      height: 100%;
      .dispaly_flex00;
      position: relative;
      margin-right: 20px;
    }
    .theme_center {
      height: 100%;
      .dispaly_flex00;
      position: relative;
      margin-right: 20px;
    }
    .theme_right {
      height: 100%;
      .dispaly_flex11;
      .display_column;
      .theme_right_div {
        height: 100%;
        width: 100%;
      }
      .theme_right_1 {
        height: 100%;
        width: 100%;
        .dispaly_flex00;
        position: relative;
      }
      .theme_right_2 {
        height: 34%;
        width: 100%;
        .dispaly_flex00;
        position: relative;
      }
      .theme_right_3 {
        margin-top: 30px;
        .dispaly_flex11;
        height: 93%;
        width: 100%;
        position: relative;
      }
    }
  }
}
</style>
<template>
  <div class="theme">
    <div class="theme_1">
      <div
        v-if="this.$store.state.staticShow"
        style="padding:30px 10px 0px 10px;"
        class="theme_left media_w_themeleft set_yj"
      >
        <titles titles="统计信息"></titles>
        <left_1></left_1>
      </div>
      <div class="theme_center media_w_themecenter set_yj">
        <titles titles="项目列表"></titles>
        <center_1></center_1>
      </div>
      <div class="theme_right media_w_themeright ">
        <div v-show="menu.new_information.judge" class="theme_right_1 set_yj">
          <titles v-if="isshow" titles="新增信息"></titles>
          <titles v-else titles="修改信息"></titles>
          <div class="theme_right_div">
            <new_information></new_information>
          </div>
        </div>
        <div
          v-show="menu.detailed_information.judge"
          :class="
            menu.data_download.judge
              ? 'theme_right_2 set_yj'
              : 'theme_right_1 set_yj'
          "
        >
          <titles titles="项目信息" style="width: 180px;"></titles>
          <div class="theme_right_div">
            <detailed_information></detailed_information>
          </div>
        </div>
        <div
          class="display_row_jc_ac dispaly_flex11"
          style="height: 100px;width:100%;"
        >
          <div
            v-show="menu.data_download.judge"
            style="width: calc(100% - 362px);padding:30px 10px 0px 10px"
            class="theme_right_3 set_yj"
          >
            <titles titles="资料管理"></titles>
            <div class="theme_right_div">
              <data_download></data_download>
            </div>
          </div>
          <div
            v-show="menu.data_download.judge"
            style="width:290px;margin-left:10px;"
            class="theme_right_3 set_yj"
          >
            <titles titles="项目状态"></titles>
            <div class="theme_right_div">
              <project_status></project_status>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import bus from "../../app/event";
import left_1 from "./left/left.vue";
import center_1 from "./center/center.vue";
import titles from "../pages/title.vue";
import data_download from "./right/data_download/data_download.vue"; //资料下载
import detailed_information from "./right/detailed_information/detailed_information.vue"; //资料详细
import new_information from "./right/new_information/new_information.vue"; //新增信息
import project_status from "./right/data_download/project_status"; //项目流转状态
export default {
  components: {
    titles,
    left_1,
    center_1,
    data_download,
    detailed_information,
    new_information,
    project_status,
    isshow: true
  },
  data() {
    return {
      menu: {
        new_information: {
          judge: false
        },
        detailed_information: {
          judge: true
        },
        data_download: {
          judge: true
        }
      }
    };
  },
  methods: {
    click_state: function(item, judge, isTorF) {
      for (var key in this.menu) {
        this.menu[key].judge = !judge;
      }
      for (var i = 0; i < item.length; i++) {
        this.menu[item[i]].judge = judge;
      }
      this.isshow = isTorF;
    },
    click_state1: function(judge) {
      // for(var key in this.menu){
      //   this.menu[key].judge = !judge;
      // }
      // for (var i = 0; i < item.length; i++) {
      //     this.menu[item[i]].judge = judge;
      // }
      this.menu.data_download.judge = !judge;
    }
  },
  mounted() {
    bus.$on("to_theme", this.click_state);

    bus.$on("detail_to_theme", this.click_state1);
  },
  beforeDestroy() {
    bus.$off("to_theme");
    bus.$off("detail_to_theme");
  }
};
</script>



// WEBPACK FOOTER //
// theme.vue?14620338